import { create } from "zustand";

interface ContactForm {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  subject: string;
  message: string;
}

interface ContactStore {
  isOpen: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  formData: ContactForm;
  openModal: () => void;
  closeModal: () => void;
  setLoading: (loading: boolean) => void;
  setSuccess: (success: boolean) => void;
  updateFormData: (data: Partial<ContactForm>) => void;
  resetForm: () => void;
}

const initialFormData: ContactForm = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  subject: "",
  message: "",
};

export const useContactStore = create<ContactStore>((set) => ({
  isOpen: false,
  isLoading: false,
  isSuccess: false,
  formData: initialFormData,
  openModal: () => set({ isOpen: true }),
  closeModal: () =>
    set({ isOpen: false, isSuccess: false, formData: initialFormData }),
  setLoading: (loading) => set({ isLoading: loading }),
  setSuccess: (success) => set({ isSuccess: success }),
  updateFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data },
    })),
  resetForm: () => set({ formData: initialFormData }),
}));
